// @flow

import { Base, Text } from '@gandi/ui';

import { PriceArea } from '../DomainCreate/components/ProvidedArea/PriceArea';
import type { ExtendedSuggestion } from '../DomainCreate/types';

import {
  AvailabilityIconLayout,
  type AvailabilityIconName,
} from './AvailabilityIcon';

import { FqdnCell } from './FqdnCell';

import styles from './DomainRowContainer.scss';

type Props = {
  fqdn: string,

  addedToCart?: boolean,
  isCartActionnable?: boolean,
  loading: boolean,

  valid?: boolean,
  corporate?: boolean,
  premium?: ExtendedSuggestion['premium'],

  cheapRenew?: boolean,
  isErrorWithRestriction?: boolean,

  availabilityIconName: AvailabilityIconName,
  availabilityText: string,

  onClickItem: (evt: SyntheticMouseEvent<>) => any,

  children: React.Node,
};

export function DomainRowContainer({
  fqdn,
  availabilityIconName,
  availabilityText,
  addedToCart = false,
  valid = false,
  premium = 0,
  cheapRenew = false,
  corporate = false,
  isErrorWithRestriction = false,
  onClickItem,
  children,
  isCartActionnable = false,
  loading,
}: Props): React.MixedElement {
  return (
    <Base
      className={styles.container}
      flex
      flexRow
      flexWrap
      flexJustifyBetween
      backgroundColor="surface"
    >
      {/* description */}
      <Base flex flexRow flexAlignItemsCenter>
        {/* checkmark (desktop) */}
        <AvailabilityIconLayout
          iconName={availabilityIconName}
          layout="desktop"
        />
        <Base flex flexCol flexJustifyAround>
          {/* checkmark (mobile) + availability text */}
          <Base
            flex
            flexRow
            flexAlignItemsCenter
            className={styles.availabilityContainer}
          >
            <AvailabilityIconLayout
              iconName={availabilityIconName}
              layout="mobile"
            />
            <Text>{availabilityText}</Text>
          </Base>
          {/* DomainProductDescription */}
          <Base
            flex
            size="bigger"
            weight="semibold"
            flexAlignItemsCenter
            flexWrap
            className={styles.domainProductDescription}
          >
            <FqdnCell
              fqdn={fqdn}
              isValid={valid}
              premium={premium}
              corporate={corporate}
              isErrorWithRestriction={isErrorWithRestriction}
              cheapRenew={cheapRenew}
            />
          </Base>
        </Base>
      </Base>
      <PriceArea
        onClick={onClickItem}
        isCartActionnable={isCartActionnable}
        addedToCart={addedToCart}
        loading={loading}
      >
        {children}
      </PriceArea>
    </Base>
  );
}
